import { render, staticRenderFns } from "./ProjectsGlobalSearch.vue?vue&type=template&id=131afdc6&lang=pug&"
import script from "./ProjectsGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./ProjectsGlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGlobalSearch.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports